export default "/e0344041b001da70bbcd83852fd0e7a7.png";